import { execute_generator } from './index'

export const api_url = process.env.VUE_APP_API_URL

export const get_actuals = (tenant, filter, booking_search, selected_company, selected_type, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/actuals/json?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&company=' + selected_company + '&type=' + selected_type + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_fasttrak_actuals = (tenant, filter, booking_search, selected_company, selected_type, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/actuals/fasttrak/json?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&company=' + selected_company + '&type=' + selected_type + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const reprocess_actuals = (tenant, filter, selected_company, selected_type, selected_status, fromDate, toDate) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/actuals/reprocess?tenant=' + tenant + '&filter=' + filter + '&status=' + selected_status + '&company=' + selected_company + '&type=' + selected_type + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_booking_dashboard = (tenant, selected_base, expireHrs, nextHrs) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/booking/dashboard?tenant=' + tenant + "&selected_base=" + selected_base + "&expire_hours=" + expireHrs + "&next_hours=" + nextHrs}
).next()

export const get_booking_feed_history = (tenant, filter, booking_search, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/feed/history?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_actuals_payroll_summary_report = (tenant, driver, from_date, to_date, reprocess, config) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/payroll/summary?tenant=' + tenant + '&driver=' + driver  + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess + (config && config.poll ? '&poll=true' : '')}, undefined, config
).next()

export const get_trip_sheet = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tripsheet?tenant=' + tenant + "&date=" + date}
).next()

export const get_driver_board = (tenant, base) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/driverboard?tenant=' + tenant + "&base=" + base}
).next()

export const get_vehicle_maint_summary = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehmaintsummary?tenant=' + tenant}
).next()

export const get_report_history = (tenant, report_type, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/history?tenant=' + tenant + '&reportType=' + report_type + '&date=' + date}
).next()

export const request_report = (tenant, report_type, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/request?tenant=' + tenant + '&reportType=' + report_type + '&date=' + date}
).next()

export const get_actuals_performance_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/performance?tenant=' + tenant + '&date=' + date}
).next()

export const get_actuals_multiday_otp_report = (tenant, base, client, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/multiday/otp?tenant=' + tenant + '&base=' + base + '&client=' + client + '&fromDate=' + fromDate + '&toDate=' + toDate }
).next()

export const get_actuals_mileage_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/mileage?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_actuals_billing_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/billing?tenant=' + tenant + '&date=' + date}
).next()

export const get_actuals_vehicle_report = (tenant, booking_type, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/vehicle?tenant=' + tenant + '&booking_type=' + booking_type + '&date=' + date}
).next()

export const get_smart_route_assignment_vehicle_types = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/smart_route_assignments/vehicle/types?tenant=' + tenant}
).next()

export const get_smart_route_assignments = (tenant, vehicleTypes, fromDate, toDate, autoselect) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/smart_route_assignments?tenant=' + tenant + '&vehicleTypes=' + vehicleTypes + '&fromDate=' + fromDate + '&toDate=' + toDate + '&autoselect=' + autoselect}
).next()

export const update_smart_route_assignment = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/smart_route_assignments?tenant=' + tenant}, body
).next()

export const get_cm_vehicle_map_future_data = (
  tenant, from_date, to_date, vehicle = '', driver = '', search = ''
) => execute_generator(
  'GET',
  {
    service: api_url,
    resource:
      'bookings/vehicle_map_future_data?tenant=' + tenant +
      '&fromDate=' + from_date +
      '&toDate='   + to_date +
      (vehicle ? '&vehicle=' + encodeURIComponent(vehicle) : '') +
      (driver  ? '&driver='  + encodeURIComponent(driver)  : '')
  }
).next()

export const get_otp_report = (tenant, date, routeFilter) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/otp?tenant=' + tenant + '&date=' + date + '&route_filter=' + routeFilter}
).next()

export const get_otp_history = (tenant, fromDate, toDate, routeFilter, tripFilter, stopFilter, vehicleFilter, driverFilter) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/otp/history?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate + '&route_filter=' + routeFilter + '&trip_filter=' + tripFilter + '&stop_filter=' + stopFilter + '&vehicle_filter=' + vehicleFilter + '&driver_filter=' + driverFilter}
).next()

export const get_actuals_driver_payroll_report = (tenant, tag, date, reprocess, config) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driverpayroll?tenant=' + tenant + '&tag=' + tag + '&date=' + date + '&reprocess=' + reprocess + (config && config.poll ? '&poll=true' : '')}, undefined, config
).next()

export const get_hos_by_client_report = (tenant, from, to, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/hoursByClient?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to + '&reprocess=' + reprocess}
).next()

export const get_actuals_drivers_daily_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driver?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_actuals_driver_multiday_report = (tenant, tag, driver, from_date, to_date, reprocess, config) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driver/multiday?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess + (config && config.poll ? '&poll=true' : '')}, undefined, config
).next()

export const get_actuals_mileage_by_booking_report = (tenant, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/mileage_by_booking?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const push_actuals_driver_multiday_to_payroll = (tenant, tag, driver, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driver/multiday/push?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_vehicle_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_driver_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/driver/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_vehicle_calendar = (tenant, hours_offset, date, base, tag) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&date=' + date + '&base=' + base + '&tag=' + tag}
).next()

export const get_vehicle_type_calendar = (tenant, hours_offset, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/type/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_driver_type_calendar = (tenant, type_mode, hours_offset, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/driver/type/calendar?tenant=' + tenant + '&type_mode=' + (type_mode || '') + '&hours_offset=' + (hours_offset || '') + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_vehicle_map = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/map?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_vehicle_map_direct = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/map/direct?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_vehicle_map_driver = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/map/driver?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_vehicle_track = (tenant, mode, value, interval) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/track?tenant=' + tenant + "&mode=" + mode + "&value=" + value + "&interval=" + interval}
).next()

export const get_vehicle_trip_history = (tenant, value, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/trip/history?tenant=' + tenant + "&vehicle=" + value + "&fromDate=" + fromDate}
).next()

export const get_vehicle_route_history = (tenant, route_name, vehicle_id, fromDate, minutesBuffer) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/route/history?tenant=' + tenant + "&route_name=" + route_name + "&vehicle=" + vehicle_id + "&fromDate=" + fromDate + "&minutesBuffer=" + minutesBuffer}
).next()

export const get_vehicle_route_locations = (tenant, routeID, minutesBuffer) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/route/locations?tenant=' + tenant + "&routeID=" + routeID + "&minutesBuffer=" + minutesBuffer}
).next()

export const get_vehicle_list = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles/list?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_route_list = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/routes/list?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_route_names = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/routes/names?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_route_patterns = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/routes/patterns?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_manage_drivers_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/manage/list?tenant=' + tenant}
).next()

export const get_driver_usernames_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/usernames/list?tenant=' + tenant}
).next()

export const get_tag_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tags/list?tenant=' + tenant}
).next()

export const get_yard_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/yards/list?tenant=' + tenant}
).next()

export const get_vehicle_track_fleet = (tenant, mode, value) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/track/fleet?tenant=' + tenant + "&mode=" + mode + "&value=" + value}
).next()

export const get_vehicle_track_reload = (tenant, mode, value) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/track/reload?tenant=' + tenant + "&mode=" + mode + "&value=" + value}
).next()

export const get_bus_tracker_results = (tenant, departureDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/bustracker?tenant=' + tenant + "&departureDate=" + departureDate}
).next()

export const get_bus_tracker_status = (tenant, departureDate, routeName, departureTime, departingFrom, arrivingAt) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/bustracker/status?tenant=' + tenant + "&departureDate=" + departureDate + "&routeName=" + routeName + "&departureTime=" + departureTime + "&departingFrom=" + departingFrom + "&arrivingAt=" + arrivingAt}
).next()

export const get_admin_dashboard = (tenant, date, tenant_filter,) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/admin/dashboard?tenant=' + tenant + '&date=' + date + '&tenant_filter=' + tenant_filter}
).next()

export const get_tenant_dashboard = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/dashboard?tenant=' + tenant + '&date=' + date}
).next()

export const get_all_tenants_config = () => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/config/all'}
).next()

export const get_tenant_config_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/config/history?tenant=' + tenant + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const register_tenant = (config) => execute_generator(
    'POST',{ service: api_url, resource: 'bookings/tenant/register'}, config).next()

export const update_tenant_config_settings = (tenant, config) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/config/settings?tenant=' + tenant}, config).next()

export const get_tenant_config_settings = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/config/settings?tenant=' + tenant}
).next()
    
export const get_alerts = (tenant, alertType, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts?tenant=' + tenant + '&alertType=' + alertType + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const delete_alert = (tenant, movementVehicleId) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/alerts?tenant=' + tenant + '&movementVehicleId=' + encodeURIComponent(movementVehicleId)}
).next()

export const get_hos_history = (tenant, driver, eventType, remarks_filter, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/hos/history?tenant=' + tenant + '&driver=' + driver + '&eventType=' + eventType + '&remarksFilter=' + remarks_filter + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const get_booking_file_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/file/history?tenant=' + tenant + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const send_event_notes_payroll_category_reports = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/event/notes/payrollcategoryreports?tenant=' + tenant + '&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const get_event_notes = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/event/notes?tenant=' + tenant + '&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const get_vehicle_info = (tenant, base, tag, return_mode) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles?tenant=' + tenant + '&base=' + base + '&tag=' + tag + '&returnMode=' + return_mode}
).next()

export const get_vehicle_info_fasttrak = (tenant, base, tag, return_mode) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles/fasttrak?tenant=' + tenant + '&base=' + base + '&tag=' + tag + '&returnMode=' + return_mode}
).next()

export const get_vehicle_info_history = (tenant, vehicleName) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles/history?tenant=' + tenant + '&vehicleName=' + vehicleName}
).next()

export const get_vehicle_status_history = (tenant, tagName, vehicleName, filter, statusFilter, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/vehiclestatus/history?tenant=' + tenant + '&tagName=' + tagName + '&vehicleName=' + vehicleName + '&filter=' + filter + '&statusFilter=' + statusFilter +'&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const reprocess_alerts_for_booking = (tenant, alert_type, booking_hash ) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts/reprocess?tenant=' + tenant + '&alertType=' + alert_type + '&bookingID=' + booking_hash }
).next()

export const test_html_alert = (tenant, alert_type ) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts/test/email/template?tenant=' + tenant + '&alertType=' + alert_type }
).next()

export const test_html_alert_param = (tenant, alert_type, event_name ) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts/test/email/template/event?tenant=' + tenant + '&alertType=' + alert_type + '&eventName=' + event_name}
).next()

export const save_booking_notes = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/notes?tenant=' + tenant}, body
).next()

export const save_event_notes = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/event/notes?tenant=' + tenant}, body
).next()

export const update_vehicle_status = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/vehicles?tenant=' + tenant}, body
).next()

export const delete_vehicle_status = (tenant, body) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/vehicles?tenant=' + tenant}, body
).next()

export const update_vehicle_status_anonymous = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/vehicles/anonymous?tenant=' + tenant}, body
).next()

export const get_sos_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/sos/history?tenant=' + tenant + '&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const get_sos_details = (tenant, request_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/sos/' + request_id + '?tenant=' + tenant}
).next()

export const send_sos_request = (tenant, vehicle_name, request_notes) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/sos/send?vehicle_name=' + vehicle_name + '&request_notes=' + request_notes + '&tenant=' + tenant}
).next()

export const delete_sos_request = (tenant, request_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/sos/' + request_id + '?tenant=' + tenant}
).next()

export const delete_booking = (tenant, booking_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/' + booking_id + '?tenant=' + tenant}
).next()

export const delete_tenant = (tenant) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/' + tenant}
).next()

export const delete_yard = (tenant, yard_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/yard?yard_name=' + yard_name + '&tenant=' + tenant}
).next()

export const add_yard = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/yard?tenant=' + tenant}, body
).next()

export const add_hos_event = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/hos/event?tenant=' + tenant}, body
).next()

export const delete_hos_event = (tenant, event_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/hos/event?event_name=' + event_name + '&tenant=' + tenant}
).next()

export const add_vehicle_late_alert_event = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/vehiclelatealert/event?tenant=' + tenant}, body
).next()

export const delete_vehicle_late_alert_event = (tenant, event_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/vehiclelatealert/event?event_name=' + event_name + '&tenant=' + tenant}
).next()

export const add_cust_event = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/cust/event?tenant=' + tenant}, body
).next()

export const delete_cust_event = (tenant, event_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/cust/event?event_name=' + event_name + '&tenant=' + tenant}
).next()

export const cancel_sos_request = (tenant, request_id) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/sos/' + request_id + '/cancel?tenant=' + tenant}
).next()

export const get_users = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/users/list?tenant=' + tenant}
).next()

export const get_primary_users = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/users/primary/list?tenant=' + tenant}
).next()

export const get_driver_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/list?tenant=' + tenant}
).next()

export const get_support_tickets = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/support_tickets/list?tenant=' + tenant}
).next()

export const search_support_tickets = (tenant, assigned, category, priority, subject, ticket_status, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/support_tickets/search?tenant=' + tenant + '&assigned=' + assigned + '&category=' + category + '&priority=' + priority + '&subject=' + subject + '&ticket_status=' + ticket_status + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const get_support_ticket = (tenant, id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/support_ticket?tenant=' + tenant + '&id=' + id}
).next()

export const get_route_addresses = (tenant, route_group, route_filter) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/route/addresses?tenant=' + tenant + '&routeGroup=' + route_group + '&routeFilter=' + route_filter}
).next()

export const get_route_assignments = (tenant, route_filter, targetDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/route/assignments?tenant=' + tenant + '&routeFilter=' + route_filter + '&targetDate=' + targetDate}
).next()

export const get_groupsender_user_list = (tenant, user_type, driverStartTime, driverEndTime) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/groupsender/users?tenant=' + tenant + '&userType=' + user_type + '&driverStartTime=' + driverStartTime + '&driverEndTime=' + driverEndTime}
).next()

export const send_message_to_group = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/groupsender/send?tenant=' + tenant}, body
).next()

export const send_message_to_user = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/groupsender/senduser?tenant=' + tenant}, body
).next()

export const get_process_manager_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/processmgr/list?tenant=' + tenant}
).next()

export const update_process_enabled = (tenant, processId, enabled) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/processmgr/' + processId + '?tenant=' + tenant + '&enabled=' + enabled}
).next()

export const disable_all_processes = () => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/processmgr/disable_all'}
).next()

export const enable_all_processes = () => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/processmgr/enable_all'}
).next()

export const delete_process_record = (tenant, processId) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/processmgr/' + processId + '?tenant=' + tenant}
).next()

export const get_user = (tenant, username) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/users/' + username + '?tenant=' + tenant}
).next()

export const get_driver = (tenant, id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/' + id + '?tenant=' + tenant}
).next()

export const delete_user = (tenant, username) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/users/' + username + '?tenant=' + tenant}
).next()

export const create_user = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/users?tenant=' + tenant}, body
).next()

export const update_user = (tenant, body) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/users?tenant=' + tenant}, body
).next()

export const update_driver = (tenant, body) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/drivers?tenant=' + tenant}, body
).next()

export const create_support_ticket = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/support_ticket?tenant=' + tenant}, body
).next()

export const update_support_ticket = (tenant, body, send_email) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/support_ticket?tenant=' + tenant + '&send_email=' + send_email}, body
).next()

export const delete_support_ticket = (tenant, ticket_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/support_tickets/' + ticket_id + '?tenant=' + tenant}
).next()

export const create_support_ticket_comment = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/support_ticket/comment?tenant=' + tenant}, body
).next()

export const update_support_ticket_comment = (tenant, body) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/support_ticket/comment?tenant=' + tenant}, body
).next()

export const delete_support_ticket_comment = (tenant, body) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/support_ticket/comment?tenant=' + tenant}, body
).next()

export const delete_support_ticket_attachments = (tenant, body) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/support_ticket/attachments?tenant=' + tenant}, body
).next()

export const presign_support_ticket_attachment = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/support_ticket/attachments/presign?tenant=' + tenant}, body
).next()

export const finalize_support_ticket_attachment = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/support_ticket/attachments/finalize?tenant=' + tenant}, body
).next()

export const send_chat_message = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/chat?tenant=' + tenant}, body
).next()

export const get_chat_session = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/chat/session?tenant=' + tenant}
).next()

export const get_ai_usage = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/ai-usage?tenant=' + tenant}
).next()

export const reset_ai_usage = (tenant) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/ai-usage?tenant=' + tenant}
).next()

export const get_ai_usage_history = (tenant, months = 12) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/ai-usage/history?tenant=' + tenant + '&months=' + months}
).next()

export const clear_chat_session = (tenant) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/chat/session?tenant=' + tenant}
).next()

export const get_chat_instructions = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/chat/instructions?tenant=' + tenant}
).next()

// Fleet Assistant documents (company-level: admin only)
export const list_fa_documents_company = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/fa-documents/company?tenant=' + tenant}
).next()

export const presign_fa_document_company = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/company/presign?tenant=' + tenant }, body
).next()

export const finalize_fa_document_company = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/company/finalize?tenant=' + tenant }, body
).next()

export const upload_fa_document_company = (tenant, formData) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/company?tenant=' + tenant }, formData
).next()

export const delete_fa_document_company = (tenant, docId) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/fa-documents/company/' + encodeURIComponent(docId) + '?tenant=' + tenant}
).next()

// Fleet Assistant documents (user-level)
export const list_fa_documents_user = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/fa-documents/user?tenant=' + tenant}
).next()

export const presign_fa_document_user = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/user/presign?tenant=' + tenant }, body
).next()

export const finalize_fa_document_user = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/user/finalize?tenant=' + tenant }, body
).next()

export const upload_fa_document_user = (tenant, formData) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/user?tenant=' + tenant }, formData
).next()

export const delete_fa_document_user = (tenant, docId) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/fa-documents/user/' + encodeURIComponent(docId) + '?tenant=' + tenant}
).next()

export const bulk_delete_fa_documents_user = (tenant, docIds) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/fa-documents/user/bulk-delete?tenant=' + tenant }, { doc_ids: docIds }
).next()

// Fleet Assistant documents (admin: storage summary & user purge)
export const get_fa_documents_summary = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/fa-documents/summary?tenant=' + tenant}
).next()

export const purge_fa_documents_user = (tenant, userId) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/fa-documents/user/' + encodeURIComponent(userId) + '/purge?tenant=' + tenant}
).next()

export const list_help_articles = (tenant, params = {}) => {
    const route_name = params.route_name ? '&route_name=' + encodeURIComponent(params.route_name) : ''
    const query = params.query ? '&query=' + encodeURIComponent(params.query) : ''
    const enabled_features = Array.isArray(params.enabled_features) && params.enabled_features.length > 0
        ? '&enabled_features=' + encodeURIComponent(params.enabled_features.join(','))
        : ''
    const limit = params.limit ? '&limit=' + encodeURIComponent(params.limit) : ''
    return execute_generator(
        'GET', { service: api_url, resource: 'bookings/help/articles?tenant=' + tenant + route_name + query + enabled_features + limit }
    ).next()
}

export const get_help_article = (tenant, docId, params = {}) => {
    const offset = params.offset ? '&offset=' + encodeURIComponent(params.offset) : ''
    const limit = params.limit ? '&limit=' + encodeURIComponent(params.limit) : ''
    return execute_generator(
        'GET', { service: api_url, resource: 'bookings/help/articles/' + encodeURIComponent(docId) + '?tenant=' + tenant + offset + limit }
    ).next()
}

export const submit_help_feedback = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/help/feedback?tenant=' + tenant }, body
).next()

export const get_help_feedback = (tenant, docId) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/help/feedback/summary?tenant=' + tenant + '&doc_id=' + encodeURIComponent(docId) }
).next()

export const list_help_company_documents = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/help/company-documents?tenant=' + tenant }
).next()

export const get_help_company_document = (tenant, docId) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/help/company-documents/' + encodeURIComponent(docId) + '?tenant=' + tenant }
).next()

export const get_url_shortener_stats = (tenant_id) => {
    const qs = tenant_id ? '?tenant_id=' + encodeURIComponent(tenant_id) : ''
    return execute_generator(
        'GET', { service: api_url, resource: 'bookings/url-shortener/stats' + qs }
    ).next()
}

export const get_url_shortener_urls = (tenant_id, start_date, end_date, limit, last_key) => {
    let qs = '?limit=' + (limit || 50)
    if (tenant_id) qs += '&tenant_id=' + encodeURIComponent(tenant_id)
    if (start_date) qs += '&start_date=' + encodeURIComponent(start_date)
    if (end_date) qs += '&end_date=' + encodeURIComponent(end_date)
    if (last_key) qs += '&last_key=' + encodeURIComponent(last_key)
    return execute_generator(
        'GET', { service: api_url, resource: 'bookings/url-shortener/urls' + qs }
    ).next()
}

export const create_url_shortener_url = (long_url, tenant_id) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/url-shortener/urls' }, { long_url, tenant_id }
).next()

export const delete_url_shortener_url = (short_code) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/url-shortener/urls/' + encodeURIComponent(short_code) }
).next()

export const get_url_shortener_clicks = (short_code, limit, last_key) => {
    let qs = '?limit=' + (limit || 50)
    if (last_key) qs += '&last_key=' + encodeURIComponent(last_key)
    return execute_generator(
        'GET', { service: api_url, resource: 'bookings/url-shortener/urls/' + encodeURIComponent(short_code) + '/clicks' + qs }
    ).next()
}

export const get_api_usage = (tenant, start_date, end_date) => {
    let qs = '?start_date=' + start_date + '&end_date=' + end_date
    if (tenant) qs += '&tenant=' + tenant
    return execute_generator(
        'GET', { service: api_url, resource: 'bookings/admin/api-usage' + qs }
    ).next()
}

export const admin_clear_cache = (tenant, cache_type) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/admin/cache/clear?tenant=' + tenant + '&cache_type=' + cache_type }
).next()
